import { createContext, useContext, useEffect, useState } from "react";
import { en } from "./locales/en";
import { pt } from "./locales/pt";
import { es } from "./locales/es";

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "pt", label: "Português", short: "PT" },
  { code: "es", label: "Spanish", short: "ES" },
];
const DICTS = { en, pt, es };
const LangCtx = createContext({ lang: "en", t: en, setLang: () => {} });

const initial = () => {
  try {
    const saved = localStorage.getItem("smartkey-lang");
    return DICTS[saved] ? saved : "en";
  } catch {
    return "en";
  }
};

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(initial);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (code) => {
    if (!DICTS[code]) return;
    setLangState(code);
    try { localStorage.setItem("smartkey-lang", code); } catch { /* storage unavailable */ }
  };

  return <LangCtx.Provider value={{ lang, t: DICTS[lang], setLang }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
